import { render, staticRenderFns } from "./DefaultNavbarDesktop.vue?vue&type=template&id=e78f6018"
import script from "./DefaultNavbarDesktop.vue?vue&type=script&lang=ts"
export * from "./DefaultNavbarDesktop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports